/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * Menu CSS
 */
export const styles = css`
  :host {
    display: block;
    position: relative;
    background: var(--nile-colors-white-base,var(--ng-colors-bg-primary));
    border: solid 1px var(--nile-custom-color-288,var(--ng-colors-border-secondary-alt));
    border-radius: var(--nile-radius-radius-lg,var(--ng-radius-md));
    overflow: hidden;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
    height: 100%;
    box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08),
      0px 8px 8px -4px rgba(16, 24, 40, 0.03);
    /* overscroll-behavior: none; */
    /* -ms-overflow-style: none; */
    /* scrollbar-width: none; */
  }

  .search__wrapper {
    box-sizing: border-box;
    padding: var(--nile-spacing-lg,var(--ng-spacing-lg)) var(--nile-spacing-sm,var(--ng-spacing-sm));
    position: sticky;
    z-index: 999;
    top: 0px;
    background: var(--nile-colors-white-base,var(--ng-colors-bg-primary));
    height: 64px;
  }

  .menu__items-wrapper {
    overflow: auto;
    max-height: var(--auto-size-available-height);
  }

  ::slotted(nile-divider) {
    --spacing: var(--nile-font-size-rem-xsmall, var(--ng-spacing-md));
  }

  .menu__footer {
    display: var(--nile-display-flex, var(--ng-display-none)); 
    /* No need to tokenize below - token not required*/
    border-radius: var(--nile-radius-sm, var(--ng-radius-xs));
    align-items: stretch;
    font-size: var(--nile-font-size-rem-large, var(--ng-font-size-text-sm));
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
    line-height: 180%;
    letter-spacing: normal;
    color: var(--nile-colors-primary-600,var(--ng-colors-text-brand-secondary-700));
    min-height: 40px;
    transition: 150ms fill;
    user-select: none;
    white-space: nowrap;
    cursor: pointer;
    padding: var(--nile-spacing-none) var(--nile-spacing-spacing-xl);
    margin: auto var(--nile-spacing-none, var(--ng-spacing-none));
  }

  .menu__footer:hover {
    background-color:var(--nile-menu-item-background-color, var(--ng-colors-bg-secondary));
  }
`;

export default [styles];
